import { IdentificationTypes } from "src/enums/IdentificationTypes";
import i18n from "src/i18n";

export function getIdInstruction(identificationType, isFront) {
  const instructionKey = "takePhoto.instructions";

  switch (identificationType) {
    case IdentificationTypes.PASSPORT:
      return i18n.t(`${instructionKey}.passport`);
    case IdentificationTypes.RESIDENCE_PERMIT:
      return i18n.t(
        `${instructionKey}.residencePermit.${isFront ? "front" : "back"}`
      );
    case IdentificationTypes.IDENTITY_CARD:
      return i18n.t(
        `${instructionKey}.identityCard.${isFront ? "front" : "back"}`
      );
    case IdentificationTypes.DRIVER_LICENSE:
      return i18n.t(`${instructionKey}.driverLicense.${isFront ? "front" : "back"}`);
    default:
      return i18n.t(`${instructionKey}.invalid`);
  }
}
